import { MISSION_STAGE_KEYS } from "../lib/format";

const SHORT = {
  intake: "I",
  product: "P",
  design: "D",
  engineering: "E",
  qa: "Q",
  security: "S",
  release: "R",
  production: "L",
};

// stagesByKey: { [key]: statusStr }.  keys missing => "pending"
export default function StageDots({ stagesByKey = {} }) {
  const passed = MISSION_STAGE_KEYS.filter(
    (k) => (stagesByKey[k] || "pending") === "passed"
  ).length;
  const pct = Math.round((passed / MISSION_STAGE_KEYS.length) * 100);
  return (
    <div className="stage-dots" aria-label={`${pct}% complete`}>
      {MISSION_STAGE_KEYS.map((k) => (
        <span
          key={k}
          className={`dot ${stagesByKey[k] || "pending"}`}
          title={`${k}: ${stagesByKey[k] || "pending"}`}
        >
          {SHORT[k]}
        </span>
      ))}
      <small>{pct}%</small>
    </div>
  );
}
